<template>
  <Listbox as="div" v-model="newGroup">
    <ListboxLabel class="inline-block align-middle text-sm font-medium text-gray-700 mr-2"> {{ $t('flow.group') }}</ListboxLabel>
    <div class="mt-1 relative inline-block align-middle">
      <ListboxButton class="relative w-full bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
        <span class="flex items-center" v-if="assignedGroup">
          <span class="ml-3 block truncate">{{ assignedGroup.attributes.name }}</span>
        </span>
        <span class="flex items-center" v-else>
          <span class="ml-3 block truncate">---</span>
        </span>
        <span class="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <SelectorIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
        </span>
      </ListboxButton>
      <transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
        <div>
          <ListboxOptions class=" shadow-2xl absolute z-10 mt-1 w-full bg-white shadow-lg max-h-56 rounded-md py-1 text-base overflow-auto focus:outline-none sm:text-sm min-w-min overflow-x-hidden">
            <ListboxOption as="template" v-for="group in groupOptions" :key="group.id" :value="group" v-slot="{ active, selected }">
              <li :class="[active ? 'text-white bg-indigo-600' : 'text-gray-900', 'cursor-default select-none relative py-2 pl-3 pr-9 min-w-min']">
                <div class="flex items-center">
                  <span :class="[selected || group.id === null && !assignedGroupId ? 'font-semibold' : 'font-normal', 'ml-3 block truncate']">
                    {{ group.attributes.name }}
                  </span>
                </div>
                <span v-if="selected || group.id === null && !assignedGroupId" :class="[active ? 'text-white' : 'text-indigo-600', 'absolute inset-y-0 right-0 flex items-center pr-4']">
                  <CheckIcon class="h-5 w-5" aria-hidden="true" />
                </span>
              </li>
            </ListboxOption>
          </ListboxOptions>
        </div>
      </transition>
    </div>
  </Listbox>
</template>

<script>
import { Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions } from '@headlessui/vue'
import { CheckIcon, SelectorIcon } from '@heroicons/vue/solid'
import { useGroupStore } from '@/stores/groups';


export default {
  components: {
    //
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    CheckIcon,
    SelectorIcon,
  },
  setup() {
    let groupStore = useGroupStore();
    return { groupStore };
  },
  created() {
    this.newGroup = this.assignedGroup;
  },
  props: ['assignedGroupId'],
  computed: {
    assignedGroup() {
      if (this.assignedGroupId) {
        return this.groupStore.getById(this.assignedGroupId);
      } else {
        return {id: null, attributes: {'name': this.$t('flow.notAssigned')}};
      }
    },
    groupOptions() {
      let options = [];
      this.groupStore.collection.forEach(g => {
        options.push(g);
      });
      options.push({id: null, attributes: {'name': this.$t('flow.notAssigned')}});
      return options;
    },
  },
  watch: {
    newGroup(newGroup) {
      if (newGroup && newGroup.id !== this.assignedGroupId) {
        this.$emit('change-assigned-group', newGroup.id);
      }
    },
    assignedGroup(currentGroup) {
      this.newGroup = currentGroup;
    },
  },
  data() {
    return {
      newGroup: undefined,
    }
  },
}
</script>
